import { IconCheck } from '@/blocks/components/Icons/IconCheck';
import { IconMinus } from '@/blocks/components/Icons/IconMinus';
import { default as MuiCheckbox } from '@mui/material/Checkbox';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { default as MuiFormControlLabel } from '@mui/material/FormControlLabel';

function NoIcon() {
  return null;
}

export const Checkbox = (props: React.ComponentProps<typeof MuiCheckbox>) => {
  return (
    <MuiCheckbox
      checkedIcon={<IconCheck />}
      icon={<NoIcon />}
      indeterminateIcon={<IconMinus />}
      disableRipple
      className={classNames(styles.checkbox, props.className)}
      {...props}
    />
  );
};

export const FormControlLabel = (props: React.ComponentProps<typeof MuiFormControlLabel>) => {
  return <MuiFormControlLabel {...props} className={classNames(styles.formControlLabel, props.className)} />;
};
